export default __webpack_public_path__ + "static/media/grafema_the-essence-collective_02.272f34fe.jpg";